'use strict';
angular.module('schoolLinqApp').factory('eventService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/events';

		function getEvent(id) {
			return $http.get(endpoint + '/' + id);
		}

		function getEvents(eventPaging) {
			return $http.get(endpoint, { params: eventPaging });
		}

		function getPageIndexForEvent(eventPaging) {
			return $http.post(endpoint + '/getPageIndexForEvent', eventPaging);
		}

		function addEvent(event) {
			return $http.post(endpoint, event);
		}

		function updateEvent(event) {
			return $http.put(endpoint + '/' + event.Id, event);
		}

		function deleteEvent(eventId) {
			return $http.delete(endpoint + '/' + eventId);
		}

		function getSponsors() {
			return $http.get(endpoint + '/sponsors');
		}

		return {
			getEvent: getEvent,
			getEvents: getEvents,
			getPageIndexForEvent: getPageIndexForEvent,
			addEvent: addEvent,
			updateEvent: updateEvent,
			deleteEvent: deleteEvent,
			getSponsors: getSponsors,
		};
	},
]);
